import { GettingStarted } from '../../widgets/getting-started';

export const IndexPage = () => {
  return <GettingStarted />;
};
